export default __webpack_public_path__ + "static/media/product-01 (1).a2628851.jpg";